
import echarts, { EChartOption } from 'echarts'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import ResizeMixin from '../mixins/resize'
import {
  dateToDatezone,
  dateToDatezoneDHM,
  dateToDatezoneHM
} from '@/utils/dateTime'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'PieChart'
})
export default class extends mixins(ResizeMixin) {
  @Prop({ default: 'chart' }) private id!: string
  @Prop({ default: '600px' }) private width!: string
  @Prop({ default: '400px' }) private height!: string
  @Prop({ required: true }) private data!: any[]
  @Prop({ required: true }) private isLoop!: boolean

  get language () {
    return AppModule.language
  }
  private title: string = ''
  private legend: string[] = []
  private tips: string = ''
  private options = {
    // 头部标题
    title: {
      top: 10,
      left: 'center',
      text: '',
      textStyle: {
        fontWeight: 'normal',
        fontSize: 18,
        color: '#000000'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
      show: true,
      transitionDuration: 0 //echart防止tooltip的抖动
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      top: 10,
      left: 10,
      data: this.legend
    },
    color: [
      '#37A2DA',
      '#ffd85c',
      '#F56C6C',
      'darkseagreen',
      'steelblue',
      'thistle'
    ],
    series: [
      {
        name: '',
        type: 'pie',
        radius: [100, 120],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 26,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: this.data
      }
    ]
  }

  @Watch('id', { immediate: true })
  private onIdChange () {
    switch (this.id) {
      case 'pieAmountProduct':
        if (this.language === 'en') {
          this.options.title.text = 'Transaction Amount'
          this.options.series[0].name = 'Product Name'
        }
        if (this.language === 'zh_cn') {
          this.options.title.text = '交易金额'
          this.options.series[0].name = '产品名称'
        }
        if (this.language === 'zh_tw') {
          this.options.title.text = '交易金額'
          this.options.series[0].name = '產品名稱'
        }
        break
      case 'pieVolumeProduct':
        if (this.language === 'en') {
          this.options.title.text = 'Transaction Volume'
          this.options.series[0].name = 'Product Name'
        }
        if (this.language === 'zh_cn') {
          this.options.title.text = '交易数量'
          this.options.series[0].name = '产品名称'
        }
        if (this.language === 'zh_tw') {
          this.options.title.text = '交易數量'
          this.options.series[0].name = '產品名稱'
        }
        break
      case 'pieAmountAccount':
        if (this.language === 'en') {
          this.options.title.text = 'Transaction Amount'
          this.options.series[0].name = 'Product Account No'
        }
        if (this.language === 'zh_cn') {
          this.options.title.text = '交易金额 '
          this.options.series[0].name = '产品账户'
        }
        if (this.language === 'zh_tw') {
          this.options.title.text = '交易金額 '
          this.options.series[0].name = '產品帳戶'
        }
        break
      case 'pieVolumeAccount':
        if (this.language === 'en') {
          this.options.title.text = 'Transaction Volume'
          this.options.series[0].name = 'Product Account No'
        }
        if (this.language === 'zh_cn') {
          this.options.title.text = '交易数量'
          this.options.series[0].name = '产品账户'
        }
        if (this.language === 'zh_tw') {
          this.options.title.text = '交易數量'
          this.options.series[0].name = '產品帳戶'
        }
        break
      default:
        break
    }
  }

  @Watch('data', { immediate: true })
  private onDataChange () {
    if (this.isLoop) {
      const oldData = this.options.series[0].data
      this.data.forEach((newItem: any) => {
        for (let index = 0; index < oldData.length; index++) {
          const item = oldData[index]
          // 在旧数据中找到对应的name则替换值，跳出本次循环
          if (newItem.name === item.name) {
            item.value = newItem.value
            break
          }
          // 找不到则追加
          if (index === oldData.length - 1) {
            this.options.legend.data.push(newItem.name)
            oldData.push(newItem)
          }
        }
      })
    } else {
      this.legend = this.data.map((item: any) => {
        return item.name
      })
      this.options.legend.data = this.legend
      this.options.series[0].data = this.data
    }
    this.$nextTick(() => {
      this.chart?.setOption(
        this.options as EChartOption<EChartOption.SeriesPie>
      )
    })
  }

  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  }

  mounted () {
    this.$nextTick(() => {
      this.initChart()
    })
  }

  private initChart () {
    this.chart = echarts.init(
      document.getElementById(this.id) as HTMLDivElement
    )
    this.chart.setOption(this.options as EChartOption<EChartOption.SeriesPie>)
  }
}
